import styles from "./Button.module.css";

export default function Button({ variant = "primary", as = "button", children, className = "", ...props }) {
  const Tag = as;
  return (
    <Tag className={`${styles.btn} ${styles[variant]} ${className}`} {...props}>
      {children}
    </Tag>
  );
}
